module.exports = __webpack_public_path__ + "281696cfa8d13738.svg";